import { createSlice } from '@reduxjs/toolkit';

// Nota multi-ruolo: `user.role` lato client rappresenta il ruolo ATTIVO (quello scelto al
// login o con lo switch), così tutti i controlli permessi esistenti seguono il ruolo con cui
// si è entrati. `user.roles` resta la lista completa per il selettore di ruolo.
const storedUser = JSON.parse(localStorage.getItem('user')) || null;

const initialState = {
  user: storedUser,
  token: localStorage.getItem('token') || null,
  activeRole: localStorage.getItem('activeRole') || storedUser?.role || null,
  isAuthenticated: !!localStorage.getItem('token'),
};

const applyActive = (user, active) => {
  if (!user) return user;
  const role = active || user.roles?.[0] || user.role;
  return { ...user, role };
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const active = action.payload.activeRole
        || action.payload.user?.roles?.[0]
        || action.payload.user?.role
        || null;
      const user = applyActive(action.payload.user, active);
      state.user = user;
      state.token = action.payload.token;
      state.activeRole = active;
      state.isAuthenticated = true;
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', action.payload.token);
      if (active) localStorage.setItem('activeRole', active);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.activeRole = null;
      state.isAuthenticated = false;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('activeRole');
    },
    updateUser: (state, action) => {
      const active = action.payload.active_role || state.activeRole || action.payload.role;
      const user = applyActive(action.payload, active);
      state.user = user;
      state.activeRole = active;
      localStorage.setItem('user', JSON.stringify(user));
      if (active) localStorage.setItem('activeRole', active);
    },
    setActiveRole: (state, action) => {
      // payload: { role, token }
      const role = action.payload.role;
      state.activeRole = role;
      state.user = applyActive(state.user, role);
      localStorage.setItem('user', JSON.stringify(state.user));
      localStorage.setItem('activeRole', role);
      if (action.payload.token) {
        state.token = action.payload.token;
        localStorage.setItem('token', action.payload.token);
      }
    },
  },
});

export const { loginSuccess, logout, updateUser, setActiveRole } = authSlice.actions;
export default authSlice.reducer;
